// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__1tTrE","header":"ClearentDisclaimer_header__2Ks8N","inner":"ClearentDisclaimer_inner__5S5Rz"};